var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","fab":"","text":"","title":"Clear current search"},on:{"click":function($event){$event.stopPropagation();return _vm.reset.apply(null, arguments)}}},[_c('v-icon',[_vm._v("fas fa fa-trash-alt")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }